import {useCheckIn} from "@hooks/check-in.ts";
import React, {useContext, useEffect} from "react";
import ScratchCard from "react-scratchcard-v2";
import {ContextAppDispatch} from "@app/context.ts";

const imgUrl = new URL('/images/scratch.png', import.meta.url).href

export const CheckInPage = () => {
    const [response, loading, error, checkIn] = useCheckIn();
    const dispatch = useContext(ContextAppDispatch);

    useEffect(() => {
        checkIn()
    }, [checkIn])

    if (error) {
        return (
            <div
                className="text-center p-6 rounded-xl bg-gradient-to-br from-orange-100/10 via-orange-50/5 to-transparent border border-orange-200 backdrop-blur-sm shadow-lg">
                <h2 className="text-2xl font-bold text-orange-400 mb-2">Greedy, we like 😏</h2>
                <p className="text-orange-300 text-lg">
                    But you’ve already claimed your daily coins today!
                </p>
                <p className="mt-2 text-orange-200">
                    Swing by again after <span className="font-semibold text-orange-400">12pm UTC</span> tomorrow to
                    grab some more loot 🤑
                </p>
            </div>
        )
    }

    if (loading || !response) {
        return (
            <div
                className="text-center p-6 rounded-xl bg-gradient-to-br from-orange-100/10 via-orange-50/5 to-transparent border border-orange-200 backdrop-blur-sm shadow-lg animate-pulse">
                <div className="text-2xl font-bold text-orange-400 mb-2">Preparing your surprise... 🎁</div>
                <div className="text-orange-300 text-lg">
                    The loot elves are working overtime. Hang tight! 🧑‍🚀✨
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-black/10 p-4">
            <div className="max-w-xl w-full">
                <ScratchCard
                    width={window.innerWidth * 0.95}
                    height={window.innerWidth * 0.95}
                    brushSize={40}
                    image={imgUrl}
                    finishPercent={85}
                    fadeOutOnComplete={true}
                    onComplete={() => dispatch({type: "APP_CONFETTI_SHOW"})}
                >
                    <div className="w-full h-full flex items-center justify-center">
                        <div
                            className="text-2xl p-6 text-center rounded-xl bg-gradient-to-br from-orange-100/20 shadow-xl border border-orange-300 text-orange-400 font-bold animate-bounce">
                            🎉 You got <span className="text-orange-500">{response!!.points}</span> coins!
                        </div>
                    </div>
                </ScratchCard>
            </div>
        </div>

    );
}